(ns web3.persistence.queries
  (:require [re-frame.core :as rf]
            [x-vec.graphql :as x]))

(declare fragment)

(x/def ^fragment entity-id-fields {:on :Entity}
  [:id {:gql/alias-of :uuid}])

(defn image-link
  "Helper function for image link fields."
  [& {:keys [width height as alias-of]
      :or {as :link
           alias-of :imageLink
           width 690
           height 500}}]
  [as (cond-> {:dimensions {:width width
                            :height height}}
              (not= as :imageLink)
              (assoc :gql/alias-of :imageLink))])

(def thumbnail-link (partial image-link :width 220 :height 188))



